import '../style.scss';
import { InputConsent } from 'views/components/molecules/establishes/inputConsent';
import { ConsentTrustFormikType, FormErrorScrollTarget } from 'views/utils/accountEstablish';
import { Button, ButtonProps } from 'views/components/atoms/button';

type ConsentTrustTemplateType = {
  formik: ConsentTrustFormikType;
  buttonProps?: {
    nextButtonProps: ButtonProps;
    prevButtonProps: ButtonProps;
  };
};

export const ConsentTrustTemplate = ({ formik, buttonProps }: ConsentTrustTemplateType) => {
  return (
    <>
      {/* FPG信託に対する承諾事項 */}
      <div className="establishWrapper">
        {!!formik.errors.distributionStatementAgreement && <FormErrorScrollTarget />}
        <InputConsent
          title="分配金計算書（租税特別措置法に基づく通知書）の提供方法についての承諾"
          name="identification"
          checkText="租税特別措置法第８条の４第４項に基づく通知書の交付に代えて、当該通知書に記載すべき事項について、電磁的方法により提供を受けることを承諾します"
          batchDangerWord="必須"
          isChecked={
            formik.values.distributionStatementAgreement ? formik.values.distributionStatementAgreement : false
          }
          setIsChecked={(e) => formik.setFieldValue('distributionStatementAgreement', e.target.checked)}
          isEnable={!!formik.errors.distributionStatementAgreement}
          errorText={formik.errors.distributionStatementAgreement}
        />
        <span className="establishWrapper_description">
          ＜分配金計算書について＞
          <br />
          分配金とは、受益証券発行信託の利益を信託の決算日ごとに受益者（投資家）の方々に分配する金銭のことをいいます
          <br />
          分配金計算書は、この分配金の額を受益者様ごとに算出した書類です
        </span>
        <span className="establishWrapper_description">
          ＜電磁的方法の種類及び内容＞
          <br />
          上記通知書に記載すべき事項の提供には次のいずれかの電磁的方法を使用いたします
          <br />
          <br />
          ・電子メールを利用する方法
          <br />
          ・株式会社FPG信託のために株式会社FPG証券のウェブページに備えられた受信者ファイルを利用する方法
          <br />
          <br />
          電磁的方法により提供を受けるためには、株式会社FPG証券が推奨するバージョン以上のPDF形式のファイル閲覧ソフト及びブラウザソフト等が必要です
        </span>
      </div>
      {buttonProps && (
        <div className="establishWrapper">
          <div className="establishWrapper_buttons">
            <Button {...buttonProps.prevButtonProps} />
            <Button {...buttonProps.nextButtonProps} />
          </div>
        </div>
      )}
    </>
  );
};
